import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// main.js 中可以统一配置
import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.prototype.$baseUrl = 'https://g60kcjt.com/prod-api';



Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')